/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CDN } from '../../../../constants';
import { ExpectedDateGenerator } from '../../../../redux/helper/DateConverter';
import OrderLevelProgress from '../ProgressBar/productlevelprogress';
import { PriceHandler } from '../../../../redux/helper/CamelCase';
import ProductsTooltip from './productsTooltip';
import DiscountTooltip from './discountTooltip';
import ItemPriceTooltip from '../../../../Components/ItemPriceTooltip';

function ApprovedOrderProductDetails({ OrderDetails, setOrderDetails, prod }) {
    const handleImage = (img) => (img ? `${CDN}/product-images/${img}` : '/images/gen.png');
    const [tooltip, setTooltip] = useState(false);
    const [netAmounthoverId, setNetAmounthoverId] = useState('');
    const [subTotalPricehoverId, setSubTotalPricehoverId] = useState('');
    const [grossAmounthoverId, setGrossAmounthoverId] = useState('');
    const [discounttooltip, setdiscounttooltip] = useState(false);
    return (
        <div className="rounded-lg bg-[#FFFFFF] shadow-s7 px-4 pb-2.5 mb-5 pt-4 m-1 relative">
            <div className="flex flex-wrap">
                <div className="w-full pt-2">
                    <div className="flex">
                        <div className="sm:w-1/4 w-[20%]">
                            <motion.img
                                initial={{ opacity: 0, scale: 0.6 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{
                                    duration: 0.8,
                                    delay: 0.5,
                                    ease: [0, 0.71, 0.2, 1.01],
                                }}
                                src={handleImage(prod?.IMAGE_NAME)}
                                alt="icon"
                                className="w-full"
                            />
                        </div>
                        <div className="pl-2.5 sm:w-full w-[80%]">
                            <div className="flex sm:items-center items-start sm:flex-row flex-col">
                                <p className="sm:text-xl text-base font-bold text-[#090406] pr-3">{prod?.MODEL_DESCRIPTION?.slice(0, 20) || `${prod?.DESCRIPTION.length > 10 ? `${prod.DESCRIPTION.slice(0, 10)}...` : `${prod.DESCRIPTION}`}`}</p>
                                <p className="text-xs font-semibold text-[#FFFFFF] bg-[#44445E] rounded px-1.5 py-1 w-fit sm:mt-0 mt-1">{prod?.MAIN_CATEGORY}</p>
                            </div>
                            <p className="sm:text-xs6 text-xs2 font-normal text-[#808285] mt-1">
                                <span>
                                    Product Code:
                                    {' '}
                                    {prod?.CONCATENATED_SEGMENTS}

                                </span>
                                <span className="sm:px-4 px-2">|</span>
                                <span>
                                    AWS Classification:
                                    {' '}
                                    {prod?.AWS_CLASSIFICATION}
                                </span>
                            </p>
                            <div className="mt-2 flex sm:items-center items-baseline sm:flex-row flex-col">
                                <div className="flex sm:border-r sm:border-[#707070] sm:pr-[6px] w-fit items-center">
                                    <p className="text-xs font-semibold text-[090406]">Category</p>
                                    <p className="text-xs3 font-semibold text-white px-1 bg-[#555259] rounded-[3px] w-fit mx-1.5">A</p>
                                    <button data-tooltip-target="tooltip-information" data-tooltip-placement="right" data-tooltip-trigger="click" type="button">
                                        <img
                                            src="/images/info_icon.svg"
                                            alt="icon"
                                            className="cursor-pointer"
                                            onMouseEnter={() => {
                                                setTimeout(() => {
                                                    setTooltip(true);
                                                }, 1000);
                                            }}
                                            onMouseLeave={() => {
                                                setTimeout(() => {
                                                    setTooltip(false);
                                                }, 2000);
                                            }}
                                        />
                                    </button>
                                    {tooltip && (
                                        <ProductsTooltip />
                                    )}

                                </div>
                                <p className="text-xs3 font-semibold text-[#808285] sm:px-[6px] sm:border-r sm:border-[#707070] sm:pt-0 pt-1">
                                    Expected Dispatch:
                                    {' '}
                                    <span className="font-bold text-[#555259]">{prod.DELIVERY_LEAD_TIME ? ExpectedDateGenerator(prod?.DELIVERY_LEAD_TIME) : '-'}</span>
                                </p>
                                <p className="text-xs3 font-semibold text-[#808285] sm:pl-[6px] sm:pt-0 pt-1">
                                    Method of Packing:
                                    {' '}
                                    <span className="font-bold text-[#555259]">{prod?.METHOD_OF_PACKING}</span>
                                </p>
                            </div>
                            <div className="flex w-full mb-5 mt-4">
                                <p className="font-normal text-xs text-[#808285] mt-2.5 w-[48%]">{prod?.DESCRIPTION}</p>
                                <div className="w-[52%] ml-7 pl-4 pr-2 pb-2 pt-2.5 bg-[#F5F5FA] rounded-lg flex flex-wrap justify-start xl:mr-4">
                                    <div className="pr-2 border-r border-[#CECECE] xl:w-auto sm:w-1/3 w-1/2">
                                        <p className="text-xs font-semibold text-[#808285]">Standard Pack Size</p>
                                        <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">
                                            {' '}
                                            {prod?.PACKING_SIZE}
                                            {' '}
                                            {prod?.PRODUCT_UOM_CODE}
                                        </p>
                                    </div>
                                    <div className="px-2 sm:border-r border-[#CECECE] xl:w-auto sm:w-1/3 w-1/2">
                                        <p className="text-xs font-semibold text-[#808285]">Size</p>
                                        {prod?.MAIN_CATEGORY !== 'EQUIPMENT' ? (
                                            <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">
                                                {`${prod.DIAMETER !== null ? `${prod.DIAMETER}mm` : ''}`}
                                                {`${prod.LENGTH !== null && prod.DIAMETER ? 'x' : ''}`}
                                                {`${prod.LENGTH !== null ? `${prod.LENGTH}mm` : ''}`}
                                                {prod.LENGTH === null && prod.DIAMETER === null ? '-' : ''}

                                            </p>
                                        ) : (
                                            <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">
                                                -

                                            </p>
                                        )}
                                    </div>
                                    <div className="sm:pl-2 pt-2 sm:pt-0">
                                        <p className="text-xs font-semibold text-[#808285]">MOQ</p>
                                        <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">{prod?.MINIMUM_ORDER_QUANTITY || 1}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="w-full border-[#CBCBCB] py-3 border-t">
                <div className="w-full flex justify-between -mx-0.5">
                    <div className="px-0.5 w-1/5">
                        <div className="pb-5 w-full">
                            <p className="text-xs3 font-semibold text-[#808285]">List Price</p>
                            <p className="text-base font-semibold text-[#15090E]">
                                {PriceHandler(prod?.LIST_PRICE)}
                            </p>
                        </div>
                    </div>
                    <div className="px-0.5 w-1/5">
                        <div className="pb-5 w-full">
                            <p className="text-xs3 font-semibold text-[#808285] text-start mr-[17px]">Quantity</p>
                            <p className="text-base font-semibold text-[#15090E]">
                                {prod?.quantity}
                                {' '}
                                {prod?.PRODUCT_UOM_CODE || prod?.PRIMARY_UOM_CODE}
                            </p>
                        </div>
                    </div>
                    <div className="px-0.5 w-1/5">
                        <div className="pb-5 w-full">
                            <p className="text-xs3 font-semibold text-[#808285]">Basic Value</p>
                            <p className="text-base font-semibold text-[#15090E]">
                                {PriceHandler(prod?.sub_total)}
                            </p>
                        </div>
                    </div>
                    <div className="px-0.5 w-1/5">
                        <div className="pb-5 w-full">
                            <p className="text-xs3 font-semibold text-[#808285] text-start mr-[17px]">Discount</p>
                            <p className="text-base font-semibold text-[#15090E]">
                                {PriceHandler((Number(prod?.discount_applied) + Number((OrderDetails.order_type === 'Trade EUB' ? prod?.revised_total_price : 0))))}
                                <span className="ml-1">
                                    <button data-tooltip-target="tooltip-discountPrice" data-tooltip-placement="right" data-tooltip-trigger="click" type="button">
                                        <img
                                            src="/images/info-filled_icon.svg"
                                            alt="icon"
                                            className="cursor-pointer"
                                            onMouseEnter={() => {
                                                setTimeout(() => {
                                                    setdiscounttooltip(true);
                                                }, 1000);
                                            }}
                                            onMouseLeave={() => {
                                                setTimeout(() => {
                                                    setdiscounttooltip(false);
                                                }, 2000);
                                            }}
                                        />
                                    </button>
                                    {discounttooltip && (
                                        <DiscountTooltip prod={prod} OrderDetails={OrderDetails} />
                                    )}

                                </span>
                            </p>
                        </div>
                    </div>
                    <div className="px-0.5 w-1/5">
                        <div className="pb-5 w-full">
                            <p className="text-xs3 font-semibold text-[#808285]">Sub Total</p>
                            <div className="flex justify-start items-center">
                                <p className="text-base font-semibold text-[#15090E] mr-1">{PriceHandler(prod.line_sub_total || 0)}</p>
                                <span>
                                    <button
                                        className="mt-2"
                                        data-tooltip-target="tooltip-discountPercentage"
                                        data-tooltip-placement="right"
                                        data-tooltip-trigger="click"
                                        type="button"
                                        onMouseEnter={() => {
                                            setSubTotalPricehoverId(prod.INVENTORY_ITEM_ID);
                                        }}
                                        onMouseLeave={() => {
                                            setSubTotalPricehoverId('');
                                        }}
                                    >
                                        <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer w-[14px] h-[14px]" />
                                    </button>
                                    {
                                        subTotalPricehoverId === prod.INVENTORY_ITEM_ID && (
                                            <ItemPriceTooltip
                                                hover={subTotalPricehoverId === prod.INVENTORY_ITEM_ID}
                                                prod={prod}
                                                itemPriceValue={Number(prod.line_sub_total) / prod.quantity}
                                                onMouseEnter={() => {
                                                    setSubTotalPricehoverId(prod.INVENTORY_ITEM_ID);
                                                }}
                                                onMouseLeave={() => {
                                                    setSubTotalPricehoverId('');
                                                }}
                                            />
                                        )
                                    }
                                    <ItemPriceTooltip prod={prod} itemPriceValue={Number(prod?.line_sub_total) / prod.quantity} />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-full flex justify-between -mx-0.5">
                    <div className="px-0.5 w-1/5">
                        <div className="w-full pb-5">
                            <p className="text-xs3 font-semibold text-[#808285]">DAP</p>
                            <p className="text-base font-semibold text-[#15090E]">{PriceHandler(prod.dap)}</p>
                        </div>
                    </div>
                    <div className="px-0.5 w-1/5">
                        <div className="w-full pb-5">
                            <p className="text-xs3 font-semibold text-[#808285] text-start mr-[17px]">Ador Cash</p>
                            <p className="text-base font-semibold text-[#15090E]">{PriceHandler(prod.ador_cash_used || 0)}</p>
                        </div>
                    </div>
                    <div className="px-0.5 w-1/5">
                        <div className="w-full pb-5">
                            <p className="text-xs3 font-semibold text-[#808285]">Net Amount</p>
                            <div className="flex justify-start items-center">
                                <p className="text-base font-semibold text-[#15090E] mr-1">{PriceHandler(prod.net_value || 0)}</p>
                                <span>
                                    <button
                                        className="mt-2"
                                        data-tooltip-target="tooltip-discountPercentage"
                                        data-tooltip-placement="right"
                                        data-tooltip-trigger="click"
                                        type="button"
                                        onMouseEnter={() => {
                                            setNetAmounthoverId(prod.INVENTORY_ITEM_ID);
                                        }}
                                        onMouseLeave={() => {
                                            setNetAmounthoverId('');
                                        }}
                                    >
                                        <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer w-[14px] h-[14px]" />
                                    </button>
                                    {
                                        netAmounthoverId === prod.INVENTORY_ITEM_ID && (
                                            <ItemPriceTooltip
                                                hover={netAmounthoverId === prod.INVENTORY_ITEM_ID}
                                                prod={prod}
                                                itemPriceValue={Number(prod?.net_value) / prod.quantity}
                                                onMouseEnter={() => {
                                                    setNetAmounthoverId(prod.INVENTORY_ITEM_ID);
                                                }}
                                                onMouseLeave={() => {
                                                    setNetAmounthoverId('');
                                                }}
                                            />
                                        )
                                    }
                                    <ItemPriceTooltip prod={prod} itemPriceValue={Number(prod?.net_value) / prod.quantity} />
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="px-0.5 w-1/5">
                        <div className="w-full pb-5">
                            <p className="text-xs3 font-semibold text-[#808285]">GST</p>
                            <p className="text-base font-semibold text-[#15090E]">{PriceHandler(prod.gst || 0)}</p>
                        </div>
                    </div>
                    <div className="px-0.5 w-1/5">
                        <div className="w-full pb-5">
                            <p className="text-xs3 font-semibold text-[#808285]">Gross Amount</p>
                            <div className="flex justify-start items-center">
                                <p className="text-base font-semibold text-[#15090E] mr-1">{PriceHandler(prod.gross_amount || 0)}</p>
                                <span>
                                    <button
                                        className="mt-2"
                                        data-tooltip-target="tooltip-discountPercentage"
                                        data-tooltip-placement="right"
                                        data-tooltip-trigger="click"
                                        type="button"
                                        onMouseEnter={() => {
                                            setGrossAmounthoverId(prod.INVENTORY_ITEM_ID);
                                        }}
                                        onMouseLeave={() => {
                                            setGrossAmounthoverId('');
                                        }}
                                    >
                                        <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer w-[14px] h-[14px]" />
                                    </button>
                                    {
                                        grossAmounthoverId === prod.INVENTORY_ITEM_ID && (
                                            <ItemPriceTooltip
                                                hover={grossAmounthoverId === prod.INVENTORY_ITEM_ID}
                                                prod={prod}
                                                itemPriceValue={Number(prod?.gross_amount) / prod.quantity}
                                                onMouseEnter={() => {
                                                    setGrossAmounthoverId(prod.INVENTORY_ITEM_ID);
                                                }}
                                                onMouseLeave={() => {
                                                    setGrossAmounthoverId('');
                                                }}
                                            />
                                        )
                                    }
                                    <ItemPriceTooltip prod={prod} itemPriceValue={Number(prod?.gross_amount) / prod.quantity} />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {Number(OrderDetails?.prod?.status) !== 0 && (OrderDetails?.order_status) !== '9' && (
                <div className="border-t border-[#CBCBCB] pt-3 overflow-auto sidebar">
                    <p className="font-semibold text-black text-xs9 pb-2 sm:px-4 px-0">Status</p>
                    <div className="overflow-auto sidebar pt-4 px-3">
                        <OrderLevelProgress OrderDetails={OrderDetails} prod={prod} />
                        <div className="flex pt-3 justify-between">
                            <p className="text-xs font-semibold text-black min-w-[120px]">Order Placed</p>
                            <p className="text-xs font-semibold text-[#555259] min-w-[120px] sm:text-center text-sta ">Order Accepted</p>
                            <p className="text-xs font-semibold text-[#555259] min-w-[120px] sm:text-end text-start ">Product Shipped</p>
                            <p className="text-xs font-semibold text-[#555259] min-w-[120px] sm:text-end text-start ">In-transit</p>
                            <p className="text-xs font-semibold text-[#555259] min-w-[120px] sm:text-end text-center pl-12">Delivered</p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default ApprovedOrderProductDetails;
